import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MfaComponent } from './mfa.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashVerificationCodeModule } from '@app/shared/modules/smash-verification-code/smash-verification-code.module';



@NgModule({
  declarations: [
    MfaComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashVerificationCodeModule,
  ],
  exports: [
    MfaComponent
  ]
})
export class MfaModule { }
